'use strict';

angular.module('sellersService')
    .factory('FeedService', [ 'appInfo', 'assoc_offices', '$rootScope', '$q', '$log', '$http'
        , function (appInfo, assoc_offices, $rootScope, $q, $log, $http) {
            var service = {}
               , code    = $rootScope.currentUser.authdata
               , api_key = appInfo.key
               , endpoint= appInfo.endpoint
               , assoc = assoc_offices.data
               , imgStack = []
               ;

            var include = function(arr, obj) {
                for(var i=0; i<arr.length; i++) {
                    if (arr[i] == obj) return true;
                }
            }

            var checkImageArr = function(url) {
                var fileExists = false;

                angular.forEach(imgStack, function(img){
                    if(url == img) {
                        fileExists = true;
                    }
                });

                if(!fileExists){
                    imgStack.push(url);
                }

                return fileExists;
            }

            service.Feed = function() {
                this.items = [];
                this.limit = 10;
                this.busy  = false;
                this.after = 0;
              };
        
            service.Feed.prototype.nextPage = function() {
                if (this.busy) return;
                this.busy = true;

                currentListing = $rootScope.currentListing;
                currentListingAgent = $rootScope.currentListing.agentInfo;
                agentIdentifier = currentListingAgent.agency[0].identifier;
                feedEvent = (currentListing.srsFeed)?'Added':'';


                $http({ url: endpoint+'otherusers/sellerlivefeed.json'
                        ,method: "GET"
                        ,transformResponse: function (data, headers) {
                            var feed = JSON.parse(data)
                                , rs = []
                                ;

                            angular.forEach(feed, function(item){
                                if (typeof item.data.body.property[0] == 'undefined') {
                                    $log.info('Error: No property in message body');
                                } else {
                                    
                                    var agencyId = parseInt(item.data.organisationId);

                                    var obj = {
                                     id           : parseInt(item.id)
                                     ,created     : parseInt(item.created)
                                     ,user        : (item.event =='sale')? item.data.sellingAgent : item.data.listingAgent
                                     ,userId      : (item.event =='sale')? parseInt(item.data.sellingAgentId) : parseInt(item.data.listingAgentId)
                                     ,agency      : item.data.agency
                                     ,identifier  : item.data.identifier
                                     ,action      : (item.event =='sale')?  "Sold" :  "Added"
                                     ,label       : (item.event =='sale')? "a Property" : "a New Listing"
                                     ,ref         : item.data.body.property[0].propertyId*12569
                                     ,meta        : { price     : item.data.body.property[0].priceView
                                                     , suburb   : item.data.suburb 
                                                     , timestamp: parseInt(item.created)
                                                     , image    : (typeof item.data.body.property[0].images !='undefined')?
                                                                  item.data.body.property[0].images[0]: 'http://dummyimage.com/800x533&text=Wiseberry'
                                                     , date     : moment.unix(parseInt(item.created)).fromNow()
                                                    }
                                     ,desc        : item.data.body.property[0].description
                                     ,icon        :item.profilePhoto
                                   };

                                   // Prepare icon image
                                    // if (item.event == 'Added') {
                                    //      var agentId= item.data.listingAgentId
                                    // } else if (item.event == 'sale') {
                                    //     var agentId= item.data.sellingAgentId
                                    // }

                                    // service.agentImageExists(agencyId, agentId).then(function(response){
                                    //     obj.icon =  response;
                                    // });
                                    
                                    rs.push(obj);
                                }
                            });

                            return rs;
                        }
                        ,params: {api_key: api_key,identifier:agentIdentifier,event:feedEvent, limit: this.limit, start: this.after}
                     }).success(function(data, status, headers, config) {
                        for (var i = 0; i < data.length; i++) {

                            var itemExists = false;
                            for (var j = 0; j < this.items.length; j++) {
                                if(data[i].id == this.items[j].id) {
                                    itemExists = true;
                                }
                            };

                            if(!itemExists)
                                this.items.push(data[i]);
                        }
                        this.after = this.items.length;
                        this.busy = false;

                    }.bind(this));
            };

            service.agentImageExists = function (agencyId, agentId) {
                angular.forEach(assoc, function(assoc){
                    if(include(assoc, agencyId)){
                        agencyId = assoc[0];
                    }
                });

                // TO DO: Check for png images as well?
                var  URl = "http://wiseberryonline.com.au/agency/"+agencyId+"/photos/"+agentId+"tb.jpg"
                    ,dfd = $q.defer()
                    ,fileExists = checkImageArr(URl);

                if(!fileExists) {
                    $http({
                        method:'GET'
                        , url: URl
                        , transformResponse: function (data, headers) { 
                            // Put url in imgStack so we can keep an eye on 
                            // the ones that we have already verified.
                            return URl;
                        }
                    }).success(function(data, status, headers, config) {
                            dfd.resolve(data);
                    }).error(function(data, status, headers, config) {
                            data = "http://www.wiseberry.com.au/images/portrait-placeholder.jpg";
                            dfd.resolve(data);
                    });
                } else {
                    dfd.resolve(URl);
                }

                return dfd.promise;
            }

            service.checkSellerFeed = function(rows, start) {
                var dfd = $q.defer();
                var limit = (start+rows);

                currentListing = $rootScope.currentListing;
                currentListingAgent = $rootScope.currentListing.agentInfo;
                agentIdentifier = currentListingAgent.agency[0].identifier;
                feedEvent = (currentListing.srsFeed)?'Added':'';

                $http({ url: endpoint+'otherusers/sellerlivefeed.json'
                        ,method: "GET"
                        ,transformResponse: function (data, headers) {
                            var feed = JSON.parse(data)
                                , rs = []
                                ;

                            angular.forEach(feed, function(item){
                                if (typeof item.data.body.property[0] == 'undefined') {
                                    $log.info('Error: No property in message body');
                                } else {
                                    
                                    var agencyId = parseInt(item.data.organisationId);

                                    var obj = {
                                     id           : parseInt(item.id)
                                     ,user        : (item.event =='sale')? item.data.sellingAgent : item.data.listingAgent
                                     ,userId      : (item.event =='sale')? parseInt(item.data.sellingAgentId) : parseInt(item.data.listingAgentId)
                                     ,agency      : item.data.agency
                                     ,action      : (item.event =='sale')?  "Sold" :  "Added"
                                     ,label       : (item.event =='sale')? "a Property" : "a New Listing"
                                     ,ref         : item.data.body.property[0].propertyId*12569
                                     ,meta        : { price     : item.data.body.property[0].priceView
                                                     , suburb   : item.data.suburb 
                                                     , timestamp: parseInt(item.created)
                                                     , image    : (typeof item.data.body.property[0].images !='undefined')?
                                                                  item.data.body.property[0].images[0]: 'http://dummyimage.com/800x533&text=Wiseberry'
                                                     , date     : moment.unix(parseInt(item.created)).fromNow()
                                                    }
                                     ,desc        : item.data.body.property[0].description
                                   };

                                   // Prepare icon image
                                    if (item.event == 'Added') {
                                         var agentId= item.data.listingAgentId
                                    } else if (item.event == 'sale') {
                                        var agentId= item.data.sellingAgentId
                                    }

                                    service.agentImageExists(agencyId, agentId).then(function(response){
                                        obj.icon =  response;
                                    });

                                   rs.push(obj);
                                }
                            });

                            return rs;
                        }
                        ,params: {api_key: api_key,identifier:agentIdentifier,event:feedEvent, limit: limit, start: start}
                     }).success(function(data, status, headers, config) {
                        dfd.resolve(data);
                    }).error(function(data, status, headers, config) {
                        dfd.reject("Error: Status " + status); 
                    });

                return dfd.promise;
            };

            return service;
    }
]);
